/**
 * Utilidades puras para listados: armar query strings y debounce de búsqueda. Sin dependencias
 * del DOM (docs/FASE-1.md §6 "TESTS": se prueban con `node --import tsx --test`).
 */

export type QueryValue = string | number | boolean | undefined | null;

/** Arma un query string a partir de un objeto, omitiendo `undefined`, `null` y cadenas vacías. */
export function toQueryString(params: Record<string, QueryValue>): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === "") continue;
    search.set(key, String(value));
  }
  const serialized = search.toString();
  return serialized.length > 0 ? `?${serialized}` : "";
}

/** Debounce genérico: retrasa la ejecución de `fn` hasta que pasen `delayMs` sin nuevas llamadas. */
export function debounce<Args extends unknown[]>(fn: (...args: Args) => void, delayMs: number): (...args: Args) => void {
  let timer: ReturnType<typeof setTimeout> | null = null;
  return (...args: Args) => {
    if (timer !== null) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      fn(...args);
    }, delayMs);
  };
}
